import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const H1Headline = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fill={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 5.5C4 5.22386 3.77614 5 3.5 5C3.22386 5 3 5.22386 3 5.5V18.5C3 18.7761 3.22386 19 3.5 19C3.77614 19 4 18.7761 4 18.5V12.5H12V18.5C12 18.7761 12.2239 19 12.5 19C12.7761 19 13 18.7761 13 18.5V5.5C13 5.22386 12.7761 5 12.5 5C12.2239 5 12 5.22386 12 5.5V11.5H4V5.5ZM19.3707 10.2727C19.8191 10.2727 20.1825 10.6362 20.1825 11.0845V18.4716C20.1825 18.7634 19.9459 19 19.6541 19C19.3623 19 19.1257 18.7634 19.1257 18.4716V11.4199C19.1257 11.3982 19.1081 11.3807 19.0864 11.3807C19.0787 11.3807 19.0711 11.3829 19.0647 11.3872L17.6386 12.3341C17.3413 12.5315 16.9439 12.3184 16.9439 11.9615C16.9439 11.8116 17.0189 11.6717 17.1437 11.5888L18.9216 10.4082C19.0547 10.3199 19.2109 10.2727 19.3707 10.2727Z"
        />
      </svg>
    )
  },
)

export default H1Headline
